import axios from 'axios';

// Con proxy (package.json "proxy": "http://127.0.0.1:8000") usar baseURL relativo para que pase por el proxy.
// Sin proxy, definir REACT_APP_API_BASE_URL=http://localhost:8000/api
const baseURL = process.env.REACT_APP_API_BASE_URL || '/api';

const api = axios.create({
    baseURL,
    timeout: 10000,
});

export default api;